var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-flex',{attrs:{"md12":""}},[_c('h1',{staticClass:"text-xs-center"},[_vm._v("Not Found")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }